import { Injectable } from '@angular/core';
import { Config } from './config';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ApiKey } from '../models/api-key';

@Injectable()
export class ApiKeyService {
    constructor(public http: HttpClient, public activatedRoute: ActivatedRoute) {}

    public getApiKeySummary(customerId: number) {
        return this.http.get<ApiKey[]>(Config.serviceUrl + Config.urls.apiKeySummary + `${customerId}`);
    }

    public addApiKey(customerId: number, description: string) {
        const postfixUri = '&description=';
        return this.http
            .post<ApiKey>(
                Config.serviceUrl + Config.urls.apiKeySummary + `${customerId}` + postfixUri + `${description}`,
                null,
            );
    }

    public editApiKey(customerId: number, keyDetail: ApiKey, activeState: boolean) {
        const postfixUriDesc = '&description=';
        const postfixUriKey = '&key=';
        const postfixUriActive = '&isActive=';

        const headers = new Headers();
        headers.append('Content-Type', 'charset=utf-8');

        const url =
            Number(customerId) +
            postfixUriKey +
            encodeURIComponent(keyDetail.key) +
            postfixUriDesc +
            encodeURIComponent(keyDetail.description) +
            postfixUriActive +
            activeState;

        return this.http.put<ApiKey>(Config.serviceUrl + Config.urls.apiKeySummary + url, { headers: headers });
    }

    public deleteApiKey(customerId: number, keyDetail: ApiKey) {
        const postfixUriKey = '&key=';
        const keyValue = encodeURIComponent(keyDetail.key);
        return this.http
            .delete<ApiKey>(
                Config.serviceUrl + Config.urls.apiKeySummary + `${Number(customerId)}` + postfixUriKey + `${keyValue}`,
            )
    }

}
